import React from 'react';

import { Card } from 'components/content-containers/cards';
import { Page, PageContent } from 'components/page';


export default function ForbiddenPage() {
  return (
    <Page>
      <PageContent>
        <Card>
          You do not have permission to view this page
        </Card>
      </PageContent>
    </Page>
  );
}
